/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import CSSModules from 'react-css-modules';
import classnames from 'classnames';
import EmptyContent from '../EmptyState/Content';
import { SURVEYS_ANSWERED_EMPTY } from '../../../constants/strings';
import styles from './index.styl';

const EmptyState = ({ centered, intl: { formatMessage } }) => (
  <div
    styleName={classnames({ placeholder: centered })}
    className={classnames({ pt3: !centered })}
  >
    <EmptyContent
      icon="no-invitations"
      text={formatMessage(SURVEYS_ANSWERED_EMPTY)}
    />
  </div>
);

EmptyState.propTypes = {
  centered: PropTypes.bool,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
};

export default injectIntl(
  CSSModules(EmptyState, styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/common/ProgramPopup/EmptyState.jsx